import React, { useRef, useEffect, useState } from "react";

const Overviewdetcard = ({
  title = "Total Token Budget",
  data = "1,000,000",
  desc = "100 users × 10,000 token",
  color = "#23B4C3",
  percentage = 100, // 🔹 Add percentage prop (0–100)
}) => {
  const pathRef = useRef(null);
  const [dot, setDot] = useState({ x: 242.251, y: 11.2667 }); // default at end

  useEffect(() => {
    if (pathRef.current) {
      const total = pathRef.current.getTotalLength();
      const pos = pathRef.current.getPointAtLength((percentage / 100) * total);
      setDot({ x: pos.x, y: pos.y });
    }
  }, [percentage]);

  return (
    <div className="box-con" style={{ gap: "4px" }}>
      <div className="overview-font">{title}</div>
      <div
        className="overview-font"
        style={{ fontWeight: "800", fontSize: "18px", color: "#374151" }}
      >
        {data}
      </div>
      <div className="overview-font" style={{ fontSize: "12px" }}>
        {desc}
      </div>

      <svg
        width="100%"
        height="101"
        viewBox="0 0 256 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_4720_12132)">
          <path
            ref={pathRef}
            d="M9.98438 63.7863C16.3167 65.6865 33.219 65.5483 50.1701 49.7941C71.359 30.1014 91.0865 35.2837 114.467 57.5675C137.848 79.8514 153.922 90.7342 178.034 60.1588C202.145 29.5833 205.068 19.2187 245.984 13"
            stroke={color}
            strokeWidth="6.76"
          />
        </g>

        {/* 🔹 Dynamic Dot */}
        <circle cx={dot.x} cy={dot.y} r="11.2667" fill={color} />

        <defs>
          <filter
            id="filter0_d_4720_12132"
            x="-0.000637054"
            y="9.6582"
            width="255.506"
            height="90.7518"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="9.01333" />
            <feGaussianBlur stdDeviation="4.50667" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.141176 0 0 0 0 0.278431 0 0 0 0 0.941176 0 0 0 0.16 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4720_12132"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4720_12132"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default Overviewdetcard;
